import { AlertTriangle } from "lucide-react";

export const FaultLabBanner = ({ realIos = false }) => (
  <div
    className="border-b border-amber-500/40 bg-amber-500/10 px-3 sm:px-6 py-2 flex items-center gap-2 text-amber-300 font-mono text-[11px] sm:text-xs uppercase tracking-[0.18em]"
    data-testid="fault-lab-banner"
  >
    <AlertTriangle size={14} className="shrink-0" />
    <span>
      This {realIos ? "real IOS node has" : "device has"} been pre-configured with a fault — find and fix it.
      <span className="hidden sm:inline text-amber-300/60"> · start with the show commands</span>
    </span>
  </div>
);
